<template>

  <div v-if="device.visit" class="btns fixed-bar">

    <el-row v-if="device.visit.inspection_status !== 'archive'" type="flex" justify="space-between">
      <el-col>
        <el-button
            @click="closeVisit(false)"
            :loading="loading"
        >Сохранить черновик
        </el-button>
        <el-button
            v-if="pdfReady"
            @click="openPdf"
            icon="el-icon-download"
            :loading="loading"
        >Скачать PDF
        </el-button>
        <el-button @click="confirmSave()" :loading="loading">Отправить</el-button>
      </el-col>
      <el-col align="right">
        <el-button type="text" icon="el-icon-refresh-right" @click="reload">Обновить данные
        </el-button>
      </el-col>
    </el-row>
    <el-row v-if="device.visit.inspection_status === 'archive'" type="flex" justify="space-between">
      <el-col>
        <el-button
            type="primary"
            @click="closeVisit(false)"
            :loading="loading"
        >Закрыть визит
        </el-button>
        <el-button
            v-if="pdfReady"
            @click="openPdf"
            icon="el-icon-download"
            :loading="loading"
        >Скачать PDF
        </el-button>
      </el-col>
      <el-col align="right">
        <el-button type="text" icon="el-icon-refresh-right" :loading="loading" @click="reload">Обновить данные
        </el-button>
      </el-col>
    </el-row>

    <el-row>

    </el-row>
  </div>
</template>
<script>
import {mapActions, mapGetters} from "vuex";

export default {
  name: "CloseVisit",
  data() {
    return {
      loading: false,

    }
  },
  computed: {
    ...mapGetters("visit", {device: "getDevices"}),
    visit() {
      return this.$route.params.visit;
    },
    pdfReady() {
      return this.device?.visit?.pdf_result_url
    }
  },
  methods: {
    ...mapActions({
      setVisit: "visit/SET_DATA",
      setStageVisit: "visit/SET_STAGE",
      setComment: "visit/SET_COMMENT",
      loadDocuments: "visit/LOAD_USER_DOCUMENTS",
    }),
    reload() {
      this.loadVisit()
    },
    loadVisit() {
      this.loading = true
      this.$api.visit
          .get(this.visit.id)
          .then(() => {
            // this.visit = response.data;
            // this.loadCardOne(1);

            this.setComment(this.visit.comment)
            this.setVisit(this.visit)
            this.loadDocuments()
            this.$emit('reload')


          })
          .catch((response) => {
            this.$notify.error({
              title: "Ошибка обновления 😕",
              message: response.response.data.message,
            })
          })
          .finally(() => {
            this.loading = false
          })
    },
    openPdf() {
      window.open(this.pdfReady, '_blank');
    },
    confirmSave() {
      this.$confirm('Отправить данные пользователю?')
          .then(() => {
            this.closeVisit(true)
          })
    },
    closeVisit(save = false) {

      let params = {
        params: {
          send: save,
        },
      }

      this.loading = true;
      this.$api.visit
          .close(this.visit.id, save ? params : {})
          .then(() => {
            this.$notify.success({
              title: save ? "Визит закрыт" : "Черновик сохранен",
            })

            this.setVisit()

            this.$router.push({
              name: "visit.list",
            })

          })
          .catch((res) => {
            this.$notify.error({
              title: "Упс..",
              message: res.response.data.message,
            });
          })
          .finally(() => {
            this.loading = !!0
          })
    },
  }

}

</script>

<style lang="scss" scoped>
.fixed-bar {
  position: sticky;
  bottom: -20px;

  z-index: 2001;

  padding: 10px 0;
  border-radius: 0;

  width: 100%;
  background: #f6f8f9 !important;
}
</style>